import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { useDictionary } from '@/src/app/hooks';
import DropdownArrow from './DropdownArrow';
import CollapsibleBox from './CollapsibleBox';
import './css/ResourcesSubheader.css';

const ResourcesSubheader: React.FC = () => {
    const { translate } = useDictionary();

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const routes = [
        { path: '/resources/assessments', label: 'Assessments', dynamic: true },
        { path: '/resources/professionalLearning', label: 'Professional Learning' },
        { path: '/resources/btbf', label: 'BTBF' },
    ];

    const currentPath = window.location.pathname;

    const match = routes.find((route) =>
        route.dynamic ? currentPath.startsWith(route.path) : currentPath === route.path
    );

    const activePage = match ? match.label : '';
    if (!activePage) return null;

    const desktopResourcesSubheader = (
        <div id="resourcesSubheader" className="resources-header background pd-grey">
            <div className="col">
                <Link
                    className={`main-nav-resources text pd-primary${activePage === 'Assessments' ? ' active' : ''}`}
                    to="/resources/assessments"
                >
                    {translate('Assessments')}
                </Link>
            </div>
            <div className="col">
                <Link
                    className={`main-nav-resources text pd-primary${activePage === 'Professional Learning' ? ' active' : ''}`}
                    to="/resources/professionalLearning"
                >
                    {translate('Professional Learning')}
                </Link>
            </div>
            <div className="col">
                <a
                    className="main-nav-resources text pd-primary"
                    href="https://mathtools.paradigmmath.com"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {translate('Math Tools')}
                </a>
            </div>
            <div className="col">
                <Link
                    className={`main-nav-resources text pd-primary${activePage === 'BTBF' ? ' active' : ''}`}
                    to="/resources/btbf"
                >
                    {translate('Beyond the Basic Facts')}
                </Link>
            </div>
        </div>
    );

    const mobileResourcesSubheader = (
        <div
            id="mobileResourcesSubheader"
            className="text pd-primary col-12 d-sm-none background pd-grey"
        >
            <a id="menuHeader">
                <span
                    id="menuTitleText"
                    className={`dropdown-labels text pd-primary${isDropdownOpen ? ' active' : ''}`}
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                    {translate(activePage)}
                </span>
                <DropdownArrow
                    id="mobileResourcesDropdownArrow"
                    rotate={isDropdownOpen ? 'down' : 'up'}
                />
            </a>
            <CollapsibleBox isOpen={isDropdownOpen} className="collapsible-content">
                <div className="col">
                    <Link
                        className={`main-nav-resources text pd-primary${activePage === 'Assessments' ? ' active' : ''}`}
                        to="/resources/assessments"
                    >
                        {translate('Assessments')}
                    </Link>
                </div>
                <div className="col">
                    <Link
                        className={`main-nav-resources text pd-primary${activePage === 'Professional Learning' ? ' active' : ''}`}
                        to="/resources/professionalLearning"
                    >
                        {translate('Professional Learning')}
                    </Link>
                </div>
                <div className="col">
                    <a
                        className="main-nav-resources text pd-primary"
                        href="https://mathtools.paradigmmath.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {translate('Math Tools')}
                    </a>
                </div>
                <div className="col">
                    <Link
                        className={`main-nav-resources text pd-primary${activePage === 'BTBF' ? ' active' : ''}`}
                        to="/resources/btbf"
                    >
                        {translate('Beyond the Basic Facts')}
                    </Link>
                </div>
            </CollapsibleBox>
        </div>
    );

    return (
        <>
            {desktopResourcesSubheader}
            {mobileResourcesSubheader}
        </>
    );
};

export default ResourcesSubheader;
